import '@/assets/scss/reset.scss'
import { createApp } from 'vue'
import App from './Index.vue'

createApp(App).mount('#app')
